<template>
    <div>
        <Header></Header>
        <b-container class="goback-button-container">
          <b-row class="mx-1 my-5 d-flex justify-content-start">
              <b-col 
                  cols='4' md='2' 
                  class="back--button btn btn-outline-danger"
                  @click="goBack()"
              >          
                <span class="mt-1">Назад</span>
              </b-col>
          </b-row>           
        </b-container>
  <b-container >
    <div class="user-address-container"> 
      <b-tabs fill>
        <b-tab  active>
          <template v-slot:title>
            {{'userAddressTabMain' | localize}} 
          </template>          
          <UserBill></UserBill>
        </b-tab>
        <b-tab title="Расчет">
          <template v-slot:title>
            {{'userAddressTabBills' | localize}} 
          </template>             
          <Invoice></Invoice>
        </b-tab>
      </b-tabs>
    </div>
  </b-container>
    </div>
</template>
<script>
import Header from '../components/Header'
import UserBill from '../components/userAddress/UserBills'
import Invoice from '../components/userAddress/Invoice'
export default {
  methods: {
    goBack(){
        this.$router.go(-1)
    },
  },
  mounted(){
    localStorage.setItem('weltumLastUrl', window.location.pathname)
  },
  components: { Header, UserBill, Invoice },
  }
</script>